import React from 'react';
import { Input, Button, Form, Card, message, Select } from 'antd';
import { FormInstance } from 'antd/lib/form';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import StatesSelect, { States, StatesSelectorType } from '../../components/public/StatesSelect';
import './page-company.less';
import CompanyService, { CompanyPostParam, CompanyPutParam, ICompanyInfo } from '../../service/company/CompanyService';
import { ADD_COMPNAY_SUCCESS_MESSAGE, ADD_COMPNAY_ERROR_MESSAGE, EDIT_COMPNAY_SUCCESS_MESSAGE, 
         EDIT_COMPNAY_ERROR_MESSAGE, GET_COMPNAY_ERROR_MESSAGE } from '../../config/strcfg';
import ErrorBoundary from 'antd/lib/alert/ErrorBoundary';
interface CompanyManagerPageState {
  loading: boolean;
  isEditMode: boolean;
  companyData: ICompanyInfo;
  uploadLogoUrl: String;
  deleteLogo: boolean;
}

class CompanyManagerPage extends React.Component<CompanyManagerPageState> {
  state : CompanyManagerPageState = {
    loading: false,
    isEditMode: false,
    companyData: null,
    uploadLogoUrl: null,
    deleteLogo: false,
  };
  
  async componentDidMount() {
    //根据url判断展示添加or编辑页面模式
    const searchParams = new URLSearchParams(window.location.hash.split('?')[1]);
    const companyId = parseInt(searchParams.get('id'));

    //编辑公司信息页面模式
    if(companyId){
      this.setState({ isEditMode: true, loading: true });
      //编辑页面需要调用公司信息查询接口
      try{
        const response = await CompanyService.getCompanyInfoById(companyId);
        if(response && response.data && response.data.companyInfo){
          this.setState({ companyData:response.data.companyInfo, loading: false }); 
          // 在此处添加条件判断，确保companyData有值之后再设置value属性
          if (this.state.companyData) {
            this.formRef.current?.setFieldsValue({ 
              name: this.state.companyData.name,
              ename: this.state.companyData.ename,
              country: this.state.companyData.country,
              province: this.state.companyData.province,
              phone: this.state.companyData.phone,
              address: this.state.companyData.address,
              nature: this.state.companyData.nature,
              industry: this.state.companyData.industry,
              postal: this.state.companyData.postal,
              fax: this.state.companyData.fax,
              level: this.state.companyData.level,
              website: this.state.companyData.website,
              remark: this.state.companyData.remark,
              states: this.state.companyData.states,
            });
          }
          else{
            this.setState({ CompanyData: null });
            message.error(GET_COMPNAY_ERROR_MESSAGE);
          }
        }
        else{
          this.setState({ CompanyData: null });
          message.error(GET_COMPNAY_ERROR_MESSAGE);
        }
      } catch(error){
        message.error(GET_COMPNAY_ERROR_MESSAGE);
      } finally{
        this.setState({ loading: false });
      }
    }
    //添加公司信息页面模式
    else{
      this.setState({ isEditMode: false });
    }
  }

  formRef = React.createRef<FormInstance>();

  // 返回按钮点击事件处理
  handleBackButtonClick = () => {
      window.history.back();
  };

  //权限选择框事件处理(不写这个空方法会导致页面任何操作都会使RoleSelect执行useEffect的接口调用)
  handleRoleSelectData = () => {
  };

  onFinish = async (params: any) => {
    this.setState({ loading: true });
    //调用addCompany接口
    if(!this.state.isEditMode){
      try {
        const response = await CompanyService.addCompany(params as CompanyPostParam);
        if(response && response.success){
          // 添加成功后的操作
          this.formRef.current?.resetFields();
          message.success(ADD_COMPNAY_SUCCESS_MESSAGE);
        }
        else{
          // 添加失败后的操作
          message.error(response.message);
        }
      } catch (error) {
          message.error(ADD_COMPNAY_ERROR_MESSAGE);
      } finally {
          this.setState({ loading: false });
      }
    }
    //调用editCompany接口
    else{
      try {
        const updatedParams = {
          ...params,  
          id: this.state.companyData.id  
        };
        const response = await CompanyService.updateCompany(updatedParams as CompanyPutParam);
        if(response && response.success){
          // 编辑成功后的操作
          this.formRef.current?.resetFields();
          message.success(EDIT_COMPNAY_SUCCESS_MESSAGE);
          // 在提交表单后等待500ms再刷新页面，加载提交后的数据
          setTimeout(() => { window.location.reload(); }, 500);
        }
        else{
          // 编辑失败后的操作
          this.formRef.current?.resetFields();
          message.error(response.message);
          setTimeout(() => { window.location.reload(); }, 500);
        }
      } catch (error) {
          this.formRef.current?.resetFields();
          message.error(EDIT_COMPNAY_ERROR_MESSAGE);
          setTimeout(() => { window.location.reload(); }, 500);
      } finally {
          this.setState({ loading: false });
      }
    }
    
  };

  render() {
    
    //form 初始值
    const initialValues = {
      states: this.state.companyData ? this.state.companyData.states : States.normal,
      remark: this.state.companyData?.remark || '',
    };

    const cardTitle = this.state.isEditMode ? "编辑客户信息" : "添加客户信息"; 
    return (
      this.state.loading === false ?
      <ErrorBoundary>
        <div className="page-company_container">
          <BreadcrumbCustom breads={['客户信息信息管理', this.state.isEditMode ? '编辑客户信息' : '添加客户信息']} />
          <Card 
            title={
                <div className="title-manager_page">
                    <Button type="link" className="back-button" onClick={this.handleBackButtonClick}>{'< 返回'}</Button>
                    {cardTitle}
                </div>
            } 
            bordered={false}
          >

              <div className="add-company_container">
                  <Form ref={this.formRef} onFinish={this.onFinish} initialValues={initialValues}>
                    <Form.Item label="公司名" name="name" className="formItem-company" rules={[{ required: true, message: '请输入公司名' }]}>
                      <Input placeholder="请输入公司名" autoComplete="off" />
                    </Form.Item>

                    <Form.Item label="公司英文名" name="ename" className="formItem-company" rules={[{ required: false }]}>
                      <Input placeholder="请输入公司英文名" autoComplete="off" />
                    </Form.Item>

                    <Form.Item label="总机" name="phone" className="formItem-company" rules={[{ required: false }]}>
                      <Input placeholder="请输入公司总机" autoComplete="off" />
                    </Form.Item>

                    <Form.Item label="地址" name="address" className="formItem-company" rules={[{ required: false }]}>
                      <Input placeholder="请输入地址" autoComplete="off" />
                    </Form.Item>

                    <Form.Item label="性质" name="nature" className="formItem-nature" rules={[{ required: false }]}>
                      <Select placeholder="请选择公司性质" className="select-nature">
                          <Select.Option value="民营">民营</Select.Option>
                          <Select.Option value="外资">外资</Select.Option>
                          <Select.Option value="合资">合资</Select.Option>
                          <Select.Option value="国有">国有</Select.Option>
                      </Select>
                    </Form.Item>

                    <Form.Item label="国家" name="country" className="formItem-common-input" rules={[{ required: false }]}>
                      <Input placeholder="请输入国家" autoComplete="off" />
                    </Form.Item>

                    <Form.Item label="省份" name="province" className="formItem-common-input" rules={[{ required: false }]}>
                      <Input placeholder="请输入省份" autoComplete="off" />
                    </Form.Item>

                    <Form.Item label="行业" name="industry" className="formItem-common-input" rules={[{ required: false }]}>
                      <Input placeholder="请输入所属行业" autoComplete="off" />
                    </Form.Item>

                    <Form.Item label="网址" name="website" className="formItem-company" rules={[{ required: false }]}>
                      <Input placeholder="请输入公司网址" autoComplete="off" />
                    </Form.Item>

                    <Form.Item label="邮编" name="postal" className="formItem-common-input" rules={[{ required: false }]}>
                      <Input placeholder="请输入公司邮编" autoComplete="off" />
                    </Form.Item>

                    <Form.Item label="传真" name="fax" className="formItem-common-input" rules={[{ required: false }]}>
                      <Input placeholder="请输入公司传真" autoComplete="off" />
                    </Form.Item>

                    <Form.Item label="备注信息" name="remark" className="formItem-introduction" rules={[{ required: false }]}>
                      <Input.TextArea 
                        placeholder="请输入公司备注信息" autoComplete="off" className="textarea-introduction" rows={4} 
                      />
                    </Form.Item>

                    <Form.Item label="状态" name="states" className="formItem-states" rules={[{ required: true, message: '请选择状态' }]} >
                      <StatesSelect 
                        showAllOption={false} 
                        selectorType={StatesSelectorType.company}
                        initialValues={this.state.companyData ? this.state.companyData.states : States.normal} 
                      />
                    </Form.Item>

                    <Form.Item>
                      <Button type="primary" className="button-company_submit" htmlType="submit" loading={this.state.loading} >
                        提交
                      </Button>
                    </Form.Item>
                  </Form>
              </div>   
          </Card>
        </div> 
      </ErrorBoundary>: ""
    );
  }
}

export default CompanyManagerPage;